<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header" v-if="isIndex()">
        <div class="row">
          <div class="col-md">
            <div class="form-group has-label">
              <label>{{ $t('common_words.request_type') }}</label>
              <el-select
                id="typeRequest"
                class="select-primary custom-width-select bus-rels shadow-sm"
                v-model="model.typeRequest"
                filterable
              >
                <el-option
                  v-for="option in typeRequests"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md" v-if="model.typeRequest == 1">
            <div class="form-group has-label">
              <label>Version</label>
              <el-select
                id="typeRequest"
                style="width: 100%"
                class="select-primary mb-3 shadow-sm"
                v-model="model.version"
                filterable
              >
                <el-option
                  v-for="option in versions"
                  class="select-primary"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md" v-if="model.typeRequest == 1">
            <div class="form-group has-label">
              <label>Estacion(es)</label>
              <el-select
                :placeholder="`${$t('common_words.select')}...`"
                id="typeRequest"
                style="width: 100%"
                class="select-primary mb-3 shadow-sm"
                v-model="model.stations_id"
                filterable
                clearable
                multiple
                collapse-tags
                @change="selectAllFromSelect('model.stations_id', stations)"
              >
                <el-option
                  v-for="option in stations"
                  class="select-primary selected-all"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md" v-if="model.typeRequest != 3">
            <div class="form-group has-label">
              <label>{{ $t('common_words.date') }} </label>
              <el-date-picker
                v-if="renderComponent"
                v-model="model.rangeDate"
                type="daterange"
                :start-placeholder="$t('common_words.initial_date')"
                :end-placeholder="$t('common_words.final_date')"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :align="'right'"
                :clearable="true"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="col-md" v-if="model.typeRequest == 3">
            <fg-input
              type="text"
              :label="$t('common_words.latitude')"
              placeholder="Latitud"
              v-model="model.lat"
              name="Latitud"
            ></fg-input>
          </div>
          <div class="col-md" v-if="model.typeRequest == 3">
            <fg-input
              type="text"
              :label="$t('common_words.longitude')"
              placeholder="Longitud"
              v-model="model.lon"
              name="Longitud"
            ></fg-input>
          </div>
        </div>
        <hr />
        <div class="row" style="justify-content: center">
          <div class="col-auto">
            <button
              class="btn btn-primary custom-shadow-btn"
              @click="getDataApi"
            >
              {{ $t('devices.station_get_data') }}
            </button>
          </div>
          <div class="col-auto" v-if="model.typeRequest == 1">
            <button
              class="btn btn-success custom-shadow-btn"
              @click="registerStationsSensors(1)"
            >
              {{ $t('devices.station_recorded') }}
            </button>
          </div>
          <div class="col-auto" v-if="model.typeRequest == 1">
            <button
              class="btn btn-warning custom-shadow-btn"
              @click="registerStationsSensors(2)"
            >
              {{ $t('devices.sensors_recorded') }}
            </button>
          </div>
        </div>
        <div class="mt-4">
          <div class="row" v-if="showReport">
            <div class="md">
              <label>{{ $t('common_words.data_of_the_day') }}</label>
              <div>
                <json-viewer :value="responseDataCurrent"></json-viewer>
              </div>
            </div>
            <div class="md">
              <label>{{ $t('climate.weather_forecast') }}</label>
              <div>
                <json-viewer :value="responseDataForecast"></json-viewer>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import i18n from 'src/i18n';
export default {
  data() {
    return {
      model: {
        typeRequest: 1,
        rangeDate: [],
        lat: 10.8906,
        lon: -74.18756,
        stations_id: [],
        version: 1,
      },
      typeRequests: [
        {
          id: 1,
          name: 'Api Metos',
        },
        {
          id: 2,
          name: 'Api Davis',
        },
        {
          id: 3,
          name: 'Api Weatherkit',
        },
      ],
      versions: [
        {
          id: 1,
          name: 'Version 1',
        },
        {
          id: 2,
          name: 'Version 2',
        },

      ],
      stations: [],
      route: null,
      showReport: false,
      responseDataCurrent: [],
      responseDataForecast: [],
    };
  },
  mixins: [MixinPermissions, mixinMasters],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.stations = this.concatAll(this.stations.splice(1));
    },
    getDataApi() {
      this.showHideLoading(true);
      this.showReport = false;
      this.responseDataCurrent = [];
      this.responseDataForecast = [];

      switch (this.model.typeRequest) {
        case 1:
          this.model.route = 'weathermetosapi/initclimatedataapimetos';
          this.backendRequest();
          break;
        case 2:
          if (this.model.rangeDate.length == 0) {
            this.route = 'weatherlinkapi/getDataApi';
          } else {
            this.route = `weatherlinkapi/getDataApi/${this.model.rangeDate}`;
          }
          this.backendRequest();
          break;
        case 3:
          if (
            this.model.lat == null ||
            this.model.lat === '' ||
            this.model.lon == null ||
            this.model.lon === ''
          ) {
            this.showHideLoading();
            SweetAlert.warning(
              i18n.t('sweet_alert.devices.longitude_latitude_warning')
            );
          } else {
            this.route = `weatherkitappleapi/getDataApi/${this.model.lat},${this.model.lon}`;
            this.backendRequest();
          }
          break;
      }
    },
    registerStationsSensors(type) {
      Axios.getMasters(`weathermetosapi/registerStationsSensors/${type}`)
        .then((response) => {
          this.showHideLoading();
          SweetAlert.success(response.data.message);
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    backendRequest() {
      if (this.model.typeRequest == 1) {
        Axios.postMasters(this.model)
          .then((response) => {
            this.showHideLoading();
            SweetAlert.success(response.data.message);
          })
          .catch((error) => {
            this.showHideLoading();
            SweetAlert.warning(error.response.data.message);
          });
      } else {
        Axios.getMasters(this.route)
          .then((response) => {
            this.showHideLoading();
            if (this.model.typeRequest == 3) {
              this.responseDataCurrent = response.data.data.currently;
              this.responseDataForecast = response.data.data.daily.data;
              this.showReport = true;
            }
            SweetAlert.success(response.data.message);
          })
          .catch((error) => {
            this.showHideLoading();
            SweetAlert.warning(error.response.data.message);
          });
      }
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([Axios.getMasters('weathermetosapi/getStationAllSelect')])
        .then((response) => {
          this.stations = this.concatAll(response[0].data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },
};
</script>
